module.exports = __webpack_public_path__ + "static/img/hlw.4c259a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/hlw.png
// module id = +6Og
// module chunks = 1